import { Logout } from '@mui/icons-material';
import {
  AppBar,
  Container,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router';
import useAppStore from 'store/useAppStore';
import cn from 'utils/cn';

const Layout = ({ children }) => {
  const isLoggedIn = useAppStore((state) => state.user.isLoggedIn);
  const userName = useAppStore((state) => state.user.name);
  const userCompany = useAppStore((state) => state.user.company);
  const logout = useAppStore((state) => state.logout);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('user_name');
    localStorage.removeItem('comp_name');
    logout();
    navigate('/login');
  };
  return (
    <>
      <AppBar position="static">
        <Container maxWidth={false} className="max-w-[1920px] px-0">
          <Toolbar>
            <Typography
              variant="h6"
              component="div"
              className={cn('grow', isLoggedIn && 'cursor-pointer')}
              onClick={() => {
                if (isLoggedIn) {
                  window.location.reload();
                }
              }}
            >
              PLC 腳本自動生成系統
            </Typography>
            {isLoggedIn && (
              <>
                <span className="mr-2">{`${userName} | ${userCompany}`}</span>
                <IconButton color="inherit" size="large" onClick={handleLogout}>
                  <Logout />
                </IconButton>
              </>
            )}
          </Toolbar>
        </Container>
      </AppBar>
      {children}
    </>
  );
};
export default Layout;
